var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","position":"relative"}},[(_vm.isEmpty)?_c('div',{staticClass:"chart-empty",style:(`height: ${_vm.height}px`)},[_vm._v("\n    暂无数据\n  ")]):_vm._e(),_c('div',{ref:"chart",style:(`height: ${_vm.height}px`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }